import React from 'react';
import { Tooltip as MuiTooltip } from '@material-ui/core'

type Props = {
    tooltip: string,
    placement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top',
    children: any
};
const Tooltip = ({tooltip, placement, children} :Props) => {
    return (
        <MuiTooltip title={tooltip} placement={placement}>
            <div>{children}</div>
        </MuiTooltip>
    )
}

export default Tooltip